










































































































































































































import {Component, Vue} from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import castAbout from "../../creditInvestigation/components/castAbout.vue";
import homeScore from "../../creditInvestigation/particulars/home-score.vue";
import {getOrganizationDetailInfo} from "@/services/api";
import {message} from "ant-design-vue";


@Component({
  components: {
    castAbout, homeScore, Footer
  },
})
export default class extends Vue {
  consumptionDetailData: any = []; // 商品消费明细列表
  value = 3;
  previewVisible = false;
  previewImage = '';
  columns = [
    {
      title: "预约单号",
      dataIndex: "seriesNum",
      align: "center"
    },
    {
      title: "评价内容",
      dataIndex: "actualAmount",
      align: "center"
    },
    {
      title: "评价人",
      dataIndex: "purchaseMethod",
      align: "center"
    },
    {
      title: "评分",
      dataIndex: "createTime",
      align: "center"
    },
  ];

  serviceProviderDetailInfo = {// 详情数据
    agencyId: "",
    agencyImage: "",
    agencyName: "",
    briefIntro: "",
    businessLicensePicture: "",
    closeTime: "",
    companyAddress: "",
    companyContactNumber: "",
    companyName: "",
    contactIdNum: "",
    contactName: "",
    contactTel: "",
    highestPrice: 0,
    joinDate: "",
    lowestPrice: 0,
    lpIdPictureNegative: "",
    lpIdPicturePositive: "",
    lpName: "",
    onStatus: 0,
    openTime: "",
    orgCharacter: "",
    orgCode: "",
    orgForm: "",
    areaSize: 0,
    bedNum: 0,
    serviceOdject: '',
    orgOveralScore: 0,
    orgTypes: null,
    organizationAttitude: 0,
    organizationSpeed: 0,
    serviceAddress: "",
    serviceCompliance: 0,
    serviceIttitude: 0,
    serviceOrderComment: null,
    serviceSaleInfo: null,
    serviceTel: "",
    totalScore: 5,
  };
  getSuccess: boolean; // 成功获取
  mounted() {
    const that = this
    let agencyId = that.$route.query['agencyId'];
    that.getSuccess = false
    if (agencyId) {
      getOrganizationDetailInfo(agencyId).then(res => {
        if (res && res.code == 0) {
          that.serviceProviderDetailInfo = res.info
          that.getSuccess = true;
        }
      })
    }
  }
  handlePicturePreview(val){
    this.previewVisible=true
    this.previewImage=val

  }
  handleCancelOK() {
    this.previewVisible = false;
  }

}
